import * as React from "react";

import { Grid, Typography, makeStyles } from "@material-ui/core";
import Empty from "../../../static/Empty";
import Image from "next/image";
import uuid from "react-uuid";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import { dateParser } from "../../../../../../../helpers/dateParser";
import {
  deleteVote,
  voteComment,
} from "../../../../../../../services/AgapeAPI";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    boxShadow: "0px 2px 15px 0px #0001",
    borderRadius: "10px",
    margin: "10px auto",
    padding: "20px 10px",
    paddingLeft: 50,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 30,
    },
  },
  body: {
    marginBottom: 50,
  },
  commentBody: {
    padding: "20px 10px",
    paddingLeft: 60,
    backgroundColor: "#FAFAFA",
    border: "solid 1px #B6B3B3",
    position: "relative",
    minHeight: 120,

    [theme.breakpoints.down("md")]: {
      paddingLeft: 40,
    },
  },
  actionBody: {
    padding: "10px 20px",
    border: "solid 1px #B6B3B3",
    borderTop: "none",
  },
  lineBody: {
    border: "solid 1px #B6B3B3",
    borderTop: "none",
    borderRight: "none",
    height: 100,
  },
  replyBody: {
    paddingLeft: 60,
    marginTop: "-50px",
  },
  imagePar: {
    position: "absolute",
    borderRadius: "100%",
    width: 80,
    height: 80,
    border: "solid 1px #B6B3B3",
    left: "-40px",
    top: 10,

    [theme.breakpoints.down("md")]: {
      width: 50,
      height: 50,
      left: "-25px",
      top: 25,
    },
  },
  image: {
    borderRadius: "100%",
  },
  t1: {
    fontSize: 18,
    color: "#292929",
    marginBottom: 5,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  t2: {
    fontSize: 16,
    color: "#292929",
    marginBottom: 5,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  positive: {
    color: "#009693",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  negative: {
    color: "#FF1339",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  love: {
    fontSize: 18,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  icon: {
    fontSize: 30,
    color: "#FF1339",
    marginBottom: "-10px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
    },
  },
  date: {
    fontSize: 16,
    textAlign: "right",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
}));

const UserComment = ({ getComments, comments }) => {
  const classes = useStyles();

  const handleDislike = (id, likeId) => {
    deleteVote(id, likeId).then((res) => {
      getComments();
    });
  };

  const handleLike = (id) => {
    voteComment(id, {
      vote: "like",
    }).then((res) => {
      getComments();
    });
  };

  return (
    <Grid container className={classes.container}>
      {comments && comments.length > 0 ? (
        comments.map((item) => (
          <Grid
            item
            xs={12}
            key={`comments-${item.id}`}
            className={classes.body}
          >
            <div className={classes.commentBody}>
              {item.user?.avatar && (
                <div className={classes.imagePar}>
                  <Image
                    src={item.user.avatar}
                    placeholder="blur"
                    blurDataURL={item.user.avatar}
                    alt="avatar"
                    width={80}
                    height={80}
                    className={classes.image}
                  />
                </div>
              )}
              <Typography variant="h4" className={classes.t1}>
                {item.user.first_name} {item.user.last_name}
              </Typography>
              <Typography variant="h5" className={classes.t2}>
                {item.content}
              </Typography>
              <Grid container>
                {item.positive[0] !== "" && (
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" className={classes.positive}>
                      نقاط قوت:
                    </Typography>
                    {item.positive.map((p) => (
                      <Typography
                        variant="h5"
                        className={classes.t2}
                        key={uuid()}
                      >
                        {p}
                      </Typography>
                    ))}
                  </Grid>
                )}
                {item.negative[0] !== "" && (
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" className={classes.negative}>
                      نقاط ضعف:
                    </Typography>
                    {item.negative.map((n) => (
                      <Typography
                        variant="h5"
                        className={classes.t2}
                        key={uuid()}
                      >
                        {n}
                      </Typography>
                    ))}
                  </Grid>
                )}
              </Grid>
            </div>
            <div className={classes.actionBody}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="h5" className={classes.love}>
                    {item.user_voted ? (
                      <FavoriteOutlinedIcon
                        className={classes.icon}
                        onClick={() =>
                          handleDislike(item.id, item.user_voted.id)
                        }
                      />
                    ) : (
                      <FavoriteBorderOutlinedIcon
                        className={classes.icon}
                        onClick={() => handleLike(item.id)}
                        style={Boolean(item.likes) ? {} : { color: "#B6B3B3" }}
                      />
                    )}{" "}
                    {item.likes}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="h5" className={classes.date}>
                    <EditCalendarOutlinedIcon className={classes.icon} />{" "}
                    {dateParser(item.created_at)}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            {item.replays &&
              item.replays.length > 0 &&
              item.replays.map((replay) => (
                <>
                  <div className={classes.lineBody} />
                  <div
                    className={classes.replyBody}
                    key={`replay-${replay.id}`}
                  >
                    <div className={classes.commentBody}>
                      {replay.user?.avatar && (
                        <div className={classes.imagePar}>
                          <Image
                            src={replay.user.avatar}
                            alt="avatar"
                            placeholder="blur"
                            blurDataURL={replay.user.avatar}
                            width={80}
                            height={80}
                            className={classes.image}
                          />
                        </div>
                      )}
                      <Typography variant="h4" className={classes.t1}>
                        {replay.user.first_name} {replay.user.last_name}
                      </Typography>
                      <Typography variant="h5" className={classes.t2}>
                        {replay.content}
                      </Typography>
                    </div>
                    <div className={classes.actionBody}>
                      <Grid container>
                        <Grid item xs={4}>
                          <Typography variant="h5" className={classes.love}>
                            {replay.user_voted ? (
                              <FavoriteOutlinedIcon
                                className={classes.icon}
                                onClick={() =>
                                  handleDislike(replay.id, replay.user_voted.id)
                                }
                              />
                            ) : (
                              <FavoriteBorderOutlinedIcon
                                className={classes.icon}
                                onClick={() => handleLike(replay.id)}
                                style={
                                  Boolean(replay.likes)
                                    ? {}
                                    : { color: "#B6B3B3" }
                                }
                              />
                            )}{" "}
                            {replay.likes}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant="h5" className={classes.date}>
                            <EditCalendarOutlinedIcon
                              className={classes.icon}
                            />{" "}
                            {dateParser(replay.created_at)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </>
              ))}
          </Grid>
        ))
      ) : (
        <Empty text="تا کنون دیدگاهی ثبت نشده است." />
      )}
    </Grid>
  );
};

export default UserComment;
